// For electric vehicles only
// Emissions per KM traveled, for electric behicles
// Sheet:!CO2 Emissions
import { zipWith } from 'lodash';
import { createSelector } from 'reselect';

import {
  calculateCumulativeAnnualGrowthRate,
  compoundGrowthSeries
} from '../../../../services/statistics';
import {
  getHasRenewableEnergyTarget,
  getNumProjectionYears,
} from '../../../selectors';

import {
  getVehicleEfficiencyOverall,
} from '../../vehicleEfficiency';

// All India average grid emission factor(kg CO2 / MWh)
// BAU: Business as Usual vs NDC (Something Compliant)
const GRID_EMISSION_DURATION = 2030 - 2015; // start/end years of projection
export const AVERAGE_GRID_EMISSION_FACTOR = {
  'BAU': calculateCumulativeAnnualGrowthRate(820, 683, GRID_EMISSION_DURATION),
  'NDC': calculateCumulativeAnnualGrowthRate(820, 638, GRID_EMISSION_DURATION),
}
const BASE_GRID_EMISSION_FACTOR = 820; // 2015

const getGridEmissionFactorSeries = createSelector([
  getNumProjectionYears
],
  (numYears) => {
    return {
      'BAU': compoundGrowthSeries(BASE_GRID_EMISSION_FACTOR, AVERAGE_GRID_EMISSION_FACTOR.BAU, numYears),
      'NDC': compoundGrowthSeries(BASE_GRID_EMISSION_FACTOR, AVERAGE_GRID_EMISSION_FACTOR.NDC, numYears),
    }
  }
)

// Add BAU version if the specs change in the future
export const getElectricEmissionsPerKm
 = createSelector([
  getVehicleEfficiencyOverall,
  getGridEmissionFactorSeries,
  getHasRenewableEnergyTarget,
],
  (efficiencySeries, emissionFactorSeries, hasRenewableEnergyTarget) => {

    const selectedEmissionSeries = hasRenewableEnergyTarget ? emissionFactorSeries.NDC : emissionFactorSeries.BAU;

    return zipWith(
      efficiencySeries,
      selectedEmissionSeries,
      (efficiency, emissionFactor) => {
        return {
          autoRickshaw: {
            commercial: efficiency.autoRickshaw.commercial * emissionFactor,
          },
          car: {
            commercial: efficiency.car.commercial * emissionFactor,
            private: efficiency.car.private * emissionFactor,

          },
          publicTransit: {
            bus: efficiency.publicTransit.bus * emissionFactor,
            metro: efficiency.publicTransit.metro * emissionFactor,
          },
          twoWheel: {
            commercial: efficiency.twoWheel.commercial * emissionFactor,
            private: efficiency.twoWheel.private * emissionFactor,
          }
        }
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/store/selectors/carbonPollution/carbonEmissionRate/electric.ts